import { render, staticRenderFns } from "./control-area.vue?vue&type=template&id=166634d1&scoped=true&"
import script from "./control-area.vue?vue&type=script&lang=js&"
export * from "./control-area.vue?vue&type=script&lang=js&"
import style0 from "./control-area.vue?vue&type=style&index=0&id=166634d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166634d1",
  null
  
)

export default component.exports